import React, { useMemo } from "react";
import { useI18n } from "../../../hooks/i18n-hooks";

import ListItem from "../../../ui_atoms/ListItem";
import VStack from "../../../ui_atoms/VStack";
import PayrollBreakdownTotalInfo from "./PayrollBreakdownTotalInfo";
import Gap from "../../../ui_atoms/Gap";
import PayrollBreakdownMonthlyInfo from "./PayrollBreakdownMonthlyInfo";
import PayrollBreakdownAbsences from "./PayrollBreakdownAbsenses";
import { PayrollBreakdownViewerProps } from "./PayrollBreakdownDetails";
import {
    PayrollBreakdownStatus,
    PayrollSourceType,
    TimeSheetState,
} from "../../../__generated__/graphql";
import Label from "../../../ui_atoms/Label";

const PayrollBreakdownMonthly: React.FC<PayrollBreakdownViewerProps> = ({
    payrollBreakdown,
    vacationStatus,
    navigation,
}) => {
    const i18n = useI18n();
    const allCompleted =
        payrollBreakdown?.timesheets?.length &&
        payrollBreakdown?.timesheets?.every(
            (ts) => ts.status === TimeSheetState.Submitted || ts.status === TimeSheetState.Accepted,
        );

    const displayInfo = useMemo(() => {
        return (
            payrollBreakdown.status === PayrollBreakdownStatus.Submitted ||
            (payrollBreakdown.missionInfo.payrollSource === PayrollSourceType.Lift && allCompleted)
        );
    }, [allCompleted, payrollBreakdown]);

    return (
        <VStack>
            {payrollBreakdown.missionInfo.payrollSource === PayrollSourceType.Lift && (
                <ListItem
                    icon="calendar"
                    description={i18n.t("payroll_breakdown.timesheets")}
                    badge={
                        !allCompleted ? (
                            <Label
                                mode="warning"
                                text={i18n.t(
                                    "screens.payroll_breakdown_editor.incomplete_timesheets",
                                )}
                            />
                        ) : undefined
                    }
                    onPress={() => {
                        navigation?.navigate("PayrollBreakdownTimeSheetScreen", {
                            payrollBreakdownId: payrollBreakdown.id,
                        });
                    }}
                />
            )}
            <Gap gap={1} />
            <VStack h="2/3">
                <PayrollBreakdownMonthlyInfo
                    payrollBreakdown={payrollBreakdown}
                    disabled={!displayInfo}
                />
                <Gap gap={0.25} />
                <PayrollBreakdownTotalInfo
                    payrollBreakdown={payrollBreakdown}
                    vacationStatus={vacationStatus}
                    disabled={!displayInfo}
                />
            </VStack>
            <PayrollBreakdownAbsences absences={payrollBreakdown.absences} />
        </VStack>
    );
};

export default PayrollBreakdownMonthly;
